export default "__VITE_ASSET__UEPg7hc8__"